<template>
  <base-layout toolbarActive :routerBack="false">
    <template #toolbarBase>
      <router-link :to="{ name: 'advertising' }" class="link text-xs-center">
        <span class="valign-middle font-weight-medium" v-if="!mobile">
          <icon-arrow class="mr-2"></icon-arrow>
          К списку рекламных кампаний
        </span>
        <span
          class="valign-middle font-weight-bold display-2 pb-0 text--secondary adv-date"
          v-if="mobile && item.id"
        >
          <icon-arrow size="17" class="mx-3"></icon-arrow>
          Редактирование рекламной кампании
        </span>
        <span
          class="valign-middle font-weight-bold display-2 pb-0 text--secondary adv-date"
          v-if="mobile && !item.id"
        >
          <icon-arrow size="17" class="mx-3"></icon-arrow>
          Добавление рекламной кампании
        </span>
      </router-link>
    </template>

    <v-container fluid grid-list-xl>
      <hint-widget
        hintName="advertisingSettings"
        type="text"
        class="mb-3 ml-3"
        btnMore
      ></hint-widget>
    </v-container>

    <v-container fluid grid-list-xl pt-0>
      <v-layout v-if="isLoaded">
        <v-flex
          v-if="!['xs'].includes($vuetify.breakpoint.name)"
          :class="{ 'layout align-center justify-center ma-0': screenLoading }"
          xl3
          lg4
          md5
        >
          <AdvertisingPreview
            v-if="!screenLoading"
            @openDialog="$emit('openDialog', $event)"
            :advId="item.id"
            type="sm"
            page="advertising"
          ></AdvertisingPreview>

          <v-progress-circular
            v-if="screenLoading"
            :size="50"
            :width="2"
            color="primary"
            indeterminate
          ></v-progress-circular>
        </v-flex>
        <v-flex
          xl9
          lg8
          md7
          class="d-flex justify-center"
          :class="{
            'content-bg--1': !['xs'].includes($vuetify.breakpoint.name)
          }"
        >
          <div class="flex xl10 pt-0 pb-5 pt-sm-5">
            <AdvertisingSettings
              @openDialog="$emit('openDialog', $event)"
              @save="save"
              @addHotspot="addHotspot"
              @deleteHotspot="deleteHotspot"
              :params="item"
            ></AdvertisingSettings>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </base-layout>
</template>

<script>
import BaseLayout from "../components/layout/BaseLayout.vue";
import IconArrow from "../components/icon/IconArrow.vue";
import AdvertisingSettings from "../components/advertising/AdvertisingSettings.vue";
import AdvertisingPreview from "../components/advertising/AdvertisingPreview.vue";
import Common from "../modules/common";
import HintWidget from "../components/common/HintWidget.vue";

export default {
  name: "AdvertisingSettingsView",

  components: {
    AdvertisingPreview,
    AdvertisingSettings,
    IconArrow,
    BaseLayout,
    HintWidget
  },

  data: () => ({
    screenLoading: false
  }),

  mounted() {
    // загружаем список хотспотов
    this.$store.dispatch("hotspotListLoad");
    // загружаем список тем
    this.$store.dispatch("themeListLoad");
    // загружаем список рекламы
    this.$store.dispatch("advListLoad");
  },

  computed: {
    id: {
      get() {
        return parseInt(this.$route.params.id);
      },
      set(val) {
        return val;
      }
    },

    isLoaded() {
      if (!this.id) {
        return true;
      } else if (this.$store.getters.advIsLoaded) {
        return true;
      }
      return false;
    },

    item() {
      let item = { ...this.$store.getters.advDefaultParams };
      if (this.id && this.isLoaded) {
        item = this.$store.getters.getAdv(this.id);
      }
      return item;
    },
    mobile() {
      return ["xs", "sm"].includes(this.$vuetify.breakpoint.name);
    }
  },

  methods: {
    /**
     * Сохранение формы в базе
     * @param params - параметры формы
     * @param changeParams - метки: выбранные checkbox для метрики
     */
    save(params, changeParams) {
      const item = { ...this.item, ...params };

      if (this.id) {
        this.edit(item).then(() => {
          this.setScreenshote(["advertising"]);
          // отправляем события в метрику
          this.sendMetrika(changeParams);
        });
      } else {
        this.create(item).then(() => {
          this.setScreenshote(["advertising"]);
          // отправляем события в метрику
          this.sendMetrika(changeParams);
        });
      }
    },

    create(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("createAdv", params)
          .then(data => {
            this.id = data.id;

            this.$router.push({
              name: "advSettings",
              params: { id: data.id }
            });

            this.$store.dispatch("popupInfoOpen", {
              text: "Реклама успешно добавлена"
            });

            resolve();
          })
          .catch(reject);
      });
    },

    /**
     * Редактирование рекламы
     */
    edit(params) {
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch("editAdv", params)
          .then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Реклама успешно изменена"
            });

            resolve();
          })
          .catch(reject);
      });
    },

    /**
     * Получение скриншотов для preview
     */
    setScreenshote(pages) {
      const item = { ...this.item };
      let themes;
      this.screenLoading = true;

      // получает скриншоты для ПК и мобильной версии и сохраняет
      Promise.all(
        ["xs", "xl"].map(size => {
          return new Promise((resolve, reject) => {
            this.$store
              .dispatch("setWifiAuthScreenshotes", {
                pages: pages,
                size: size,
                advertising_id: item.id
              })
              .then(resolve)
              .catch(reject);
          });
        })
      )
        .then(values => {
          let items = {};
          values.forEach(value => {
            items = { ...items, ...value };
          });
          item.params.preview = { ...item.params.preview, ...items };

          this.$store.dispatch("editAdv", item).then(() => {
            // открываем сообщение
            this.$store.dispatch("popupInfoOpen", {
              text: "Скриншоты обновлены"
            });
            this.screenLoading = false;
          });
        })
        .catch(error => {
          console.error(error);
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: "Ошибка при обновлении скриншотов",
            type: "error"
          });
          this.screenLoading = false;
        });

      // если реклама прикреплена к темам, обновим скрины в темах
      themes = this.$store.getters.themeList.filter(
        theme => theme.advertising_id === item.id
      );
      themes.forEach(theme => {
        theme.params.preview.advertising = item.params.preview.advertising;
        this.$store.dispatch("editTheme", {
          id: theme.id,
          params: theme.params
        });

        this.$store
          .dispatch("setWifiAuthScreenshotes", {
            pages: pages,
            theme_id: theme.id,
            advertising_id: item.id
          })
          .then(values => {
            theme.params.preview.advertising = values.advertising;
            this.$store.dispatch("editTheme", {
              id: theme.id,
              params: theme.params
            });
          });
      });
    },

    /**
     * Отправляет события рекламы в метрику
     * @param changeParams - метки: выбранные checkbox для метрики
     */
    sendMetrika(changeParams) {
      if (changeParams.clientsNew) {
        Common.sendMetrika("newclient");
      }
      if (changeParams.clientsAgain) {
        Common.sendMetrika("secondtimeclient");
      }
      if (changeParams.clientsMany) {
        Common.sendMetrika("regularclient");
      }
      Common.sendMetrika("keepit");
    },
    /**
     * Изменение поля advertising_id у хотспота
     */
    editHotspotAdv(hotspot_id, message, deleted) {
      let params = {
        ...this.$store.getters.hotspotList.find(item => item.id === hotspot_id),
        advertising_id: this.item.id,
        deleted: deleted ? true : false
      };
      this.$store
        .dispatch("pinHotspotAdv", params)
        .then(() => {
          // открываем сообщение
          this.$store.dispatch("popupInfoOpen", {
            text: message
          });
        })
        .catch();
    },
    // прикрепление рекламы к хотспоту
    addHotspot(params) {
      if (this.item.id)
        this.editHotspotAdv(
          params.hotspot_id,
          "Реклама успешно прикреплена к хотспоту"
        );
      else
        this.create(params.advertising).then(() => {
          // скриншоты
          this.setScreenshote(["advertising"]);
          // отправляем события в метрику
          this.sendMetrika(params.changeParams);
          // прикрепление рекламы к хотспоту
          this.editHotspotAdv(
            params.hotspot_id,
            "Реклама успешно прикреплена к хотспоту"
          );
        });
    },
    // открпелние рекламы от хотспота
    deleteHotspot(hotspot_id) {
      this.editHotspotAdv(
        hotspot_id,
        "Реклама успешно откреплена от хотспота",
        true
      );
    }
  }
};
</script>
